import routesPaths from "routes/routesPaths";

import { ReactComponent as TradeIcon } from "assets/icons/swap.svg";
import { ReactComponent as EarningIcon } from "assets/icons/earning.svg";
import { ReactComponent as WalletIcon } from "assets/icons/wallet.svg";
import { ReactComponent as HourglassIcon } from "assets/icons/hourglass.svg";
import { ReactComponent as LineChartUpIcon } from "assets/icons/line-chart-up.svg";
import { ReactComponent as CardIcon } from "assets/icons/card.svg";
import { ReactComponent as GameIcon } from "assets/icons/game.svg";
import { ReactComponent as GiftIcon } from "assets/icons/gift.svg";
import { ReactComponent as CartIcon } from "assets/icons/cart.svg";
import { ReactNode } from "react";

export interface AppNav {
  key: string;
  path: string;
  label: string;
  icon: ReactNode;
}

export const claimRoute: AppNav = {
  key: "claim",
  path: routesPaths.claim,
  label: "CLAIM_PAGE",
  icon: <GiftIcon />,
};

let mainNav: AppNav[] = [
  {
    key: "trade",
    path: routesPaths.trade,
    label: "TRADE",
    icon: <TradeIcon />,
  },
  {
    key: "earning",
    path: routesPaths.earning,
    // label: process.env.REACT_APP_ENVIRONMENT === "dev" ? "EARNING" : "STAKING",
    label: "STAKING",
    icon: <EarningIcon />,
  },
  {
    key: "wallet",
    path: routesPaths.wallet,
    label: "WALLET",
    icon: <WalletIcon />,
  },
  {
    key: "history",
    path: routesPaths.history,
    label: "HISTORY",
    icon: <HourglassIcon />,
  },

  {
    key: "crypto-cards",
    path: routesPaths.cryptoCards,
    label: "CRYPTO_CARDS",
    icon: <CardIcon />,
  },
  {
    key: "games",
    path: routesPaths.games,
    label: "GAMES",
    icon: <GameIcon />,
  },
  {
    key: "gift-cards",
    path: routesPaths.giftCards,
    label: "GIFT_CARDS",
    icon: <CardIcon />,
  },
];

if (process.env.REACT_APP_ENVIRONMENT === "dev") {
  mainNav.push(
    {
      key: "futures",
      path: routesPaths.futures,
      label: "FUTURES",
      icon: <LineChartUpIcon />,
    },
    {
      key: "membership",
      path: routesPaths.membership,
      label: "MEMBERSHIP",
      icon: <CartIcon />,
    }
  );
}

const futuresNav: AppNav[] = [
  {
    key: "trade",
    path: routesPaths.futures,
    label: "TRADE",
    icon: <LineChartUpIcon />,
  },
  {
    key: "balances",
    path: routesPaths.futuresBalances,
    label: "BALANCES",
    icon: <WalletIcon />,
  },
];

export { mainNav, futuresNav };
